import React from 'react'
// components
import SchemaField from '../SchemaField'
import { Collapse } from 'components/UI'
// schemas
import { ChartSchemaNode } from '../../schema'
// types
import { ChartType } from 'types/charts'
// views
import { Section, SectionBody, SectionTitle } from '../../../../views'
// utils
import { getVisibleEntries } from '../../utils'

interface Props {
  name: string
  node: ChartSchemaNode
  chartType: ChartType
}

// A collapsible section of the fields of one schema object that the chart type uses
const SchemaSection: React.FC<Props> = ({ name, node, chartType }) => {
  const [isCollapsed, setIsCollapsed] = React.useState(true)

  const fields = getVisibleEntries(node, chartType)

  if (!fields.length) {
    return null
  }

  return (
    <Section>
      <Collapse isCollapsed={isCollapsed} handleClick={() => setIsCollapsed(!isCollapsed)}>
        <SectionTitle title={node.description}>{node.title}</SectionTitle>
      </Collapse>
      {!isCollapsed && (
        <SectionBody>
          {fields.map(([key, child]) => (
            <SchemaField key={key} name={`${name}.${key}`} sectionName={name} node={child} />
          ))}
        </SectionBody>
      )}
    </Section>
  )
}

export default SchemaSection
